/**
 * Dashboard > Dashboard - Fault 상세 정보 조회 component
 */
import API from '@/views/Fdc/Apis/'

export default {
  name: 'LiveFaultDetail',
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.search()
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 50, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_DATE'), field: 'alarmDt', width: 160, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL_NAME'), field: 'modelName', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL_TYPE'), field: 'modelType', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAULT'), field: 'faultYn', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.WARNING'), field: 'warningYn', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM_MESSAGE'), field: 'alarmMsg', width: 100, hide: true }
      ]
    },
    /**
     * Data 조회 (Fault 상세 정보 목록)
     */
    async search () {
      const payload = {
        // fab: 'BRIQUE'
      }

      await API.Monitor.getFaultDetail(payload, this.callbackFaultDetail, [this.$refs.liveFaultDetailGrid])
    },
    /**
     * Data 조회
     * @param {*} response Data 조회 결과
     */
    callbackFaultDetail (response) {
      if (response && response.status === 200) {
        this.rowData = response.data
      }
    }
  },
  data () {
    return {
      rowData: [], // Fault 상세 정보 row data
      columns: [], // Fault 상세 정보 grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true,
        editable: false
      } // BRIQUE Grid column default setting
    }
  }
}
